module.exports = __webpack_public_path__ + "static/media/logo_light_no_border.589fd175.svg";